module.exports = __webpack_public_path__ + "static/img/铁人三项.1b57881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/home/铁人三项.svg
// module id = p+lm
// module chunks = 0